import { TextItemSchema } from 'cms/schemaTypes/staticPages/objects/textItem'

import CustomPortableText from 'lib/sanity/richText/CustomPortableText'
import FormattedText from 'shared/ui/FormattedText'

import {
  PageTitle,
  SectionContainer,
  SectionContent
} from '../landings/styles'

import styles from './QualityGuaranteeHeroSection.module.scss'

interface QualityGuaranteeHeroSectionProps {
  header: string
  guaranteeSection: TextItemSchema
}

const QualityGuaranteeHeroSection = ({
  header,
  guaranteeSection
}: QualityGuaranteeHeroSectionProps) => {
  return (
    <SectionContainer className={styles.section}>
      <SectionContent $top={3} $topMobile={3} $bottom={10} $bottomMobile={10}>
        <PageTitle>
          <FormattedText text={header} />
        </PageTitle>
        <CustomPortableText value={guaranteeSection.textField || []} />
      </SectionContent>
    </SectionContainer>
  )
}

export default QualityGuaranteeHeroSection
